import API from './api';

const fetchAllPages = async (endpoint, resourceKey) => {
    const limit = 100;
    const firstResponse = await API.get(endpoint, { params: { page: 1, limit } });
    const firstPageItems = firstResponse.data.data[resourceKey] || [];
    const totalPages = firstResponse.data.pagination?.totalPages || 1;
    const remainingResponses = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, index) =>
            API.get(endpoint, { params: { page: index + 2, limit } })
        )
    );

    return [
        ...firstPageItems,
        ...remainingResponses.flatMap(response => response.data.data[resourceKey] || []),
    ];
};

const serviceService = {
    getAllServices: async (filters = {}) => {
        const { category, subcategory, search } = filters;
        let url = '/services';
        const params = [];
        if (category) params.push(`category=${encodeURIComponent(category)}`);
        if (subcategory) params.push(`subcategory=${encodeURIComponent(subcategory)}`);
        if (search) params.push(`search=${encodeURIComponent(search)}`);
        if (params.length > 0) url += `?${params.join('&')}`;
        const response = await API.get(url);
        return response.data;
    },

    getServiceById: async (id) => {
        const response = await API.get(`/services/${id}`);
        return response.data;
    },

    getCategories: async () => {
        const response = await API.get('/services/categories');
        return response.data;
    },

    getCategoriesWithSubcategories: async () => {
        const [categories, subcategories] = await Promise.all([
            fetchAllPages('/services/categories', 'categories'),
            fetchAllPages('/services/subcategories', 'subcategories'),
        ]);
        const categoriesWithSubcategories = categories.map(cat => ({
            ...cat,
            id: cat._id,
            subcategories: subcategories.filter(
                sub => (sub.category?._id || sub.category) === (cat._id?.toString?.() || cat._id)
            ),
        }));
        return { success: true, data: { categories: categoriesWithSubcategories } };
    },

    getFeaturedServices: async () => {
        const response = await API.get('/services/featured');
        return response.data;
    },

    getSubCategories: async (categoryId = '') => {
        const url = categoryId ? `/services/subcategories?category=${categoryId}` : '/services/subcategories';
        const response = await API.get(url);
        return response.data;
    },


    getSubcategoriesByCategoryId: async (categoryId) => {
        const response = await API.get(`/services/categories/${categoryId}/subcategories`);
        return response.data;
    },

    getServicesBySubcategoryId: async (subcategoryId) => {
        const response = await API.get(`/services/subcategories/${subcategoryId}/services`);
        return response.data;
    },

    getServiceReviews: async (serviceId, page = 1, limit = 5) => {
        const response = await API.get(`/services/${serviceId}/reviews?page=${page}&limit=${limit}`);
        return response.data;
    },

    submitReview: async (serviceId, payload) => {
        // payload: { rating, review }
        const response = await API.post(`/services/${serviceId}/reviews`, payload);
        return response.data;
    },

    updateReview: async (serviceId, reviewId, payload) => {
        const response = await API.put(`/services/${serviceId}/reviews/${reviewId}`, payload);
        return response.data;
    },
};

export default serviceService;